import { Schema as S } from "effect"

export namespace RedirectTo {
  export const Key = "redirectTo" as const

  // One leading slash, not followed by another or a backslash: `//host` and
  // `/\host` name another host. Browsers drop control characters such as tabs
  // before resolving, which would turn `/\t/host` into `//host`
  export const isSitePath = (redirectTo: string): boolean => {
    return /^\/(?![/\\])/.test(redirectTo) && !/\p{Cc}/u.test(redirectTo)
  }

  // Anything but a path on this site decodes as absent, so a route that redirects
  // to it without AppResponse.RedirectTo falls back to its default
  const SitePath = S.transform(S.String, S.UndefinedOr(S.String), {
    strict: true,
    decode: (redirectTo) => {
      return isSitePath(redirectTo) ? redirectTo : undefined
    },
    encode: (redirectTo) => {
      return redirectTo ?? ""
    },
  })

  export const Schema = S.Struct({ [Key]: S.optional(SitePath) })
}
